export const supabaseUrl = process.env.NEXT_PUBLIC_SUPABASE_URL
  || process.env.VITE_SUPABASE_URL
  || 'https://frwfsybeezicmriyttmf.supabase.co';

// Public anon key only; this is intentionally browser-safe and never a service-role secret.
export const supabaseAnonKey = process.env.NEXT_PUBLIC_SUPABASE_ANON_KEY
  || process.env.VITE_SUPABASE_ANON_KEY
  || 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImZyd2ZzeWJlZXppY21yaXl0dG1mIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NTY0NzYzOTIsImV4cCI6MjA3MjA1MjM5Mn0.SNFY4BlKK8CyrtyNwNPMhNOzKR1T6DP_VVtcKMY053g';
